import yup from '@/libs/yup';

export default yup.object({
    name: yup.string().trim().required('Name is a required field').idn(),
    default_value: yup.string()
});
